export default "__VITE_ASSET__C0uSUMX4__";